import { LinkState } from '@/store/modules/link/types';

const linkState: LinkState = {
  '@context': '',
  '@id': '',
  '@type': '',
  'hydra:member': [],
  'hydra:totalItems': 0,
  'hydra:view': null,
};
export default linkState;
